import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react';

type TDealContextState = {
  expandedOffer: string | null;
  setExpandedOffer: Dispatch<SetStateAction<string | null>>;
};
const DealContext = createContext<TDealContextState>({
  expandedOffer: null,
  setExpandedOffer: () => {},
});

export const useDealContext = (): TDealContextState => useContext(DealContext);

export function DealsContextProvider({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  const [expandedOffer, setExpandedOffer] = useState<string | null>(null);

  return (
    <DealContext.Provider value={{ setExpandedOffer, expandedOffer }}>
      {children}
    </DealContext.Provider>
  );
}
